/*! js-cookie v3.0.5 | MIT */
function l(o) {
  for (var r = 1; r < arguments.length; r++) {
    var s = arguments[r];
    for (var d in s)
      o[d] = s[d];
  }
  return o;
}
var h = {
  read: function(o) {
    return o[0] === '"' && (o = o.slice(1, -1)), o.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(o) {
    return encodeURIComponent(o).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function a(o, r) {
  function s(n, c, e) {
    if (!(typeof document > "u")) {
      e = l({}, r, e), typeof e.expires == "number" && (e.expires = new Date(Date.now() + e.expires * 864e5)), e.expires && (e.expires = e.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var t = "";
      for (var i in e)
        e[i] && (t += "; " + i, e[i] !== !0 && (t += "=" + e[i].split(";")[0]));
      return document.cookie = n + "=" + o.write(c, n) + t;
    }
  }
  function d(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var c = document.cookie ? document.cookie.split("; ") : [], e = {}, t = 0; t < c.length; t++) {
        var i = c[t].split("="), u = i.slice(1).join("=");
        try {
          var f = decodeURIComponent(i[0]);
          if (e[f] = o.read(u, f), n === f)
            break;
        } catch {
        }
      }
      return n ? e[n] : e;
    }
  }
  return Object.create(
    {
      set: s,
      get: d,
      remove: function(n, c) {
        s(
          n,
          "",
          l({}, c, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return a(this.converter, l({}, this.attributes, n));
      },
      withConverter: function(n) {
        return a(l({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(r) },
      converter: { value: Object.freeze(o) }
    }
  );
}
var p = a(h, { path: "/" });
const g = () => typeof window < "u" && typeof window.document < "u", w = () => !g(), C = () => globalThis.location.host.startsWith("beta"), m = () => p.get("IS_CANARY") === "true", x = () => p.get("fondof_internal") === "true", I = () => globalThis.location.host.includes("stage."), R = () => globalThis.location.host.includes("dev.") || globalThis.location.host.includes("localhost"), U = () => globalThis.location.host.includes("www.");
export {
  C as isBeta,
  g as isBrowser,
  m as isCanary,
  R as isDev,
  x as isInternal,
  U as isProd,
  w as isSSR,
  I as isStage
};
//# sourceMappingURL=env.js.map
